module.exports = __webpack_public_path__ + "img/split_icon.d7d7dab1.svg";